// extracted by mini-css-extract-plugin
module.exports = {"col_preguntaRespuesta":"RadioGroup_col_preguntaRespuesta__3BB4T","respuestasCuestionario":"RadioGroup_respuestasCuestionario__1rGJ3"};